import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpErrorResponse,
  HttpClientModule
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, tap, map } from "rxjs/operators";
import { INewsfeed } from "../models/newsfeed.model";
import { environment } from "src/environments/environment";
//import { error } from "protractor";


@Injectable({
  providedIn: "root"
})
export class NewsfeedService {
  private baseurl: string;

  constructor(private http: HttpClient) {
    let rootURL = environment.apiConfig.apiUrl;
    //let rootURL = BuildEnvironment.GetEnvironmentUrl();
    this.baseurl = rootURL;
  }

  getAllNewsfeed() {
    return this.http.get(this.baseurl + "/newsfeeds");
    //return this.http.get(this.baseurl + "/newsfeeds",{observe: 'response'});
  }

  getNewsfeedById(newsfeedid): Observable<INewsfeed> {
    try {
      return this.http.get<INewsfeed>(
        this.baseurl + "/newsfeeds/" + newsfeedid
      );
    } catch (err) {
      console.log("---------Unexpected error occured-------");
    }
    return this.http.get<INewsfeed>(
      this.baseurl + "/newsfeeds/" + newsfeedid
    );
  }

  insertNewsfeed(formdata:any) {
    try {
      return this.http.post(this.baseurl + "/newsfeeds/insert", formdata);
    } catch (err) {
      console.log("-------Error occurred posting----" + err);
    }
    return this.http.post(this.baseurl + "/newsfeeds/insert", formdata);
  }
  updateNewsfeed(formdata : any, newsfeedid : number) {
    try {
      return this.http.post(
        this.baseurl + "/newsfeeds/update/" + newsfeedid,
        formdata
      );
      //.subscribe(result => console.log(result));
    } catch (error) {
      throwError(error);
    }
  }
  deleteNewsfeed(newsfeedid : number) {
    return this.http.delete(this.baseurl + "/newsfeeds/" + newsfeedid, {
      headers: {},
      params: { newsfeedid: newsfeedid }
    });
  }

  private handleError(err: HttpErrorResponse) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage = "";
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Server returned code: ${err.status}, error message is: ${err.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
